module.exports = __webpack_public_path__ + "static/media/firm_qr_code.04ea7a4d.png";